/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard.index'
import { Route as DashboardWaitlistRouteImport } from './routes/dashboard.waitlist'
import { Route as DashboardSubscriptionsRouteImport } from './routes/dashboard.subscriptions'
import { Route as DashboardProjectsRouteImport } from './routes/dashboard.projects'
import { Route as DashboardInvitesRouteImport } from './routes/dashboard.invites'
import { Route as DashboardFilesRouteImport } from './routes/dashboard.files'
import { Route as DashboardEarningsRouteImport } from './routes/dashboard.earnings'
import { Route as DashboardAuditLogsRouteImport } from './routes/dashboard.audit-logs'
import { Route as DashboardWalletsIndexRouteImport } from './routes/dashboard.wallets.index'
import { Route as DashboardUsersIndexRouteImport } from './routes/dashboard.users.index'
import { Route as DashboardTodoIndexRouteImport } from './routes/dashboard.todo.index'
import { Route as DashboardModelManagementIndexRouteImport } from './routes/dashboard.model-management.index'
import { Route as DashboardJobsIndexRouteImport } from './routes/dashboard.jobs.index'
import { Route as DashboardCanvasIndexRouteImport } from './routes/dashboard.canvas.index'
import { Route as DashboardWalletsUserIdRouteImport } from './routes/dashboard.wallets.$userId'
import { Route as DashboardUsersIdRouteImport } from './routes/dashboard.users.$id'
import { Route as DashboardTodoCategoriesRouteImport } from './routes/dashboard.todo.categories'
import { Route as DashboardTodoCategoryIdRouteImport } from './routes/dashboard.todo.$categoryId'
import { Route as DashboardModelManagementSplatRouteImport } from './routes/dashboard.model-management.$'
import { Route as DashboardJobsIdRouteImport } from './routes/dashboard.jobs.$id'
import { Route as DashboardCanvasUuidRouteImport } from './routes/dashboard.canvas.$uuid'
import { Route as DashboardAnalyticsModelsRouteImport } from './routes/dashboard.analytics.models'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardWaitlistRoute = DashboardWaitlistRouteImport.update({
  id: '/waitlist',
  path: '/waitlist',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardSubscriptionsRoute = DashboardSubscriptionsRouteImport.update({
  id: '/subscriptions',
  path: '/subscriptions',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardProjectsRoute = DashboardProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardInvitesRoute = DashboardInvitesRouteImport.update({
  id: '/invites',
  path: '/invites',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardFilesRoute = DashboardFilesRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardEarningsRoute = DashboardEarningsRouteImport.update({
  id: '/earnings',
  path: '/earnings',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAuditLogsRoute = DashboardAuditLogsRouteImport.update({
  id: '/audit-logs',
  path: '/audit-logs',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardWalletsIndexRoute = DashboardWalletsIndexRouteImport.update({
  id: '/wallets/',
  path: '/wallets/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardUsersIndexRoute = DashboardUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardTodoIndexRoute = DashboardTodoIndexRouteImport.update({
  id: '/todo/',
  path: '/todo/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardModelManagementIndexRoute =
  DashboardModelManagementIndexRouteImport.update({
    id: '/model-management/',
    path: '/model-management/',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardJobsIndexRoute = DashboardJobsIndexRouteImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardCanvasIndexRoute = DashboardCanvasIndexRouteImport.update({
  id: '/canvas/',
  path: '/canvas/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardWalletsUserIdRoute = DashboardWalletsUserIdRouteImport.update({
  id: '/wallets/$userId',
  path: '/wallets/$userId',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardUsersIdRoute = DashboardUsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardTodoCategoriesRoute = DashboardTodoCategoriesRouteImport.update({
  id: '/todo/categories',
  path: '/todo/categories',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardTodoCategoryIdRoute = DashboardTodoCategoryIdRouteImport.update({
  id: '/todo/$categoryId',
  path: '/todo/$categoryId',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardModelManagementSplatRoute =
  DashboardModelManagementSplatRouteImport.update({
    id: '/model-management/$',
    path: '/model-management/$',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardJobsIdRoute = DashboardJobsIdRouteImport.update({
  id: '/jobs/$id',
  path: '/jobs/$id',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardCanvasUuidRoute = DashboardCanvasUuidRouteImport.update({
  id: '/canvas/$uuid',
  path: '/canvas/$uuid',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardAnalyticsModelsRoute =
  DashboardAnalyticsModelsRouteImport.update({
    id: '/analytics/models',
    path: '/analytics/models',
    getParentRoute: () => DashboardRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/login': typeof LoginRoute
  '/dashboard/audit-logs': typeof DashboardAuditLogsRoute
  '/dashboard/earnings': typeof DashboardEarningsRoute
  '/dashboard/files': typeof DashboardFilesRoute
  '/dashboard/invites': typeof DashboardInvitesRoute
  '/dashboard/projects': typeof DashboardProjectsRoute
  '/dashboard/subscriptions': typeof DashboardSubscriptionsRoute
  '/dashboard/waitlist': typeof DashboardWaitlistRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/analytics/models': typeof DashboardAnalyticsModelsRoute
  '/dashboard/canvas/$uuid': typeof DashboardCanvasUuidRoute
  '/dashboard/jobs/$id': typeof DashboardJobsIdRoute
  '/dashboard/model-management/$': typeof DashboardModelManagementSplatRoute
  '/dashboard/todo/$categoryId': typeof DashboardTodoCategoryIdRoute
  '/dashboard/todo/categories': typeof DashboardTodoCategoriesRoute
  '/dashboard/users/$id': typeof DashboardUsersIdRoute
  '/dashboard/wallets/$userId': typeof DashboardWalletsUserIdRoute
  '/dashboard/canvas/': typeof DashboardCanvasIndexRoute
  '/dashboard/jobs/': typeof DashboardJobsIndexRoute
  '/dashboard/model-management/': typeof DashboardModelManagementIndexRoute
  '/dashboard/todo/': typeof DashboardTodoIndexRoute
  '/dashboard/users/': typeof DashboardUsersIndexRoute
  '/dashboard/wallets/': typeof DashboardWalletsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/dashboard/audit-logs': typeof DashboardAuditLogsRoute
  '/dashboard/earnings': typeof DashboardEarningsRoute
  '/dashboard/files': typeof DashboardFilesRoute
  '/dashboard/invites': typeof DashboardInvitesRoute
  '/dashboard/projects': typeof DashboardProjectsRoute
  '/dashboard/subscriptions': typeof DashboardSubscriptionsRoute
  '/dashboard/waitlist': typeof DashboardWaitlistRoute
  '/dashboard': typeof DashboardIndexRoute
  '/dashboard/analytics/models': typeof DashboardAnalyticsModelsRoute
  '/dashboard/canvas/$uuid': typeof DashboardCanvasUuidRoute
  '/dashboard/jobs/$id': typeof DashboardJobsIdRoute
  '/dashboard/model-management/$': typeof DashboardModelManagementSplatRoute
  '/dashboard/todo/$categoryId': typeof DashboardTodoCategoryIdRoute
  '/dashboard/todo/categories': typeof DashboardTodoCategoriesRoute
  '/dashboard/users/$id': typeof DashboardUsersIdRoute
  '/dashboard/wallets/$userId': typeof DashboardWalletsUserIdRoute
  '/dashboard/canvas': typeof DashboardCanvasIndexRoute
  '/dashboard/jobs': typeof DashboardJobsIndexRoute
  '/dashboard/model-management': typeof DashboardModelManagementIndexRoute
  '/dashboard/todo': typeof DashboardTodoIndexRoute
  '/dashboard/users': typeof DashboardUsersIndexRoute
  '/dashboard/wallets': typeof DashboardWalletsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/login': typeof LoginRoute
  '/dashboard/audit-logs': typeof DashboardAuditLogsRoute
  '/dashboard/earnings': typeof DashboardEarningsRoute
  '/dashboard/files': typeof DashboardFilesRoute
  '/dashboard/invites': typeof DashboardInvitesRoute
  '/dashboard/projects': typeof DashboardProjectsRoute
  '/dashboard/subscriptions': typeof DashboardSubscriptionsRoute
  '/dashboard/waitlist': typeof DashboardWaitlistRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/analytics/models': typeof DashboardAnalyticsModelsRoute
  '/dashboard/canvas/$uuid': typeof DashboardCanvasUuidRoute
  '/dashboard/jobs/$id': typeof DashboardJobsIdRoute
  '/dashboard/model-management/$': typeof DashboardModelManagementSplatRoute
  '/dashboard/todo/$categoryId': typeof DashboardTodoCategoryIdRoute
  '/dashboard/todo/categories': typeof DashboardTodoCategoriesRoute
  '/dashboard/users/$id': typeof DashboardUsersIdRoute
  '/dashboard/wallets/$userId': typeof DashboardWalletsUserIdRoute
  '/dashboard/canvas/': typeof DashboardCanvasIndexRoute
  '/dashboard/jobs/': typeof DashboardJobsIndexRoute
  '/dashboard/model-management/': typeof DashboardModelManagementIndexRoute
  '/dashboard/todo/': typeof DashboardTodoIndexRoute
  '/dashboard/users/': typeof DashboardUsersIndexRoute
  '/dashboard/wallets/': typeof DashboardWalletsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/login'
    | '/dashboard/audit-logs'
    | '/dashboard/earnings'
    | '/dashboard/files'
    | '/dashboard/invites'
    | '/dashboard/projects'
    | '/dashboard/subscriptions'
    | '/dashboard/waitlist'
    | '/dashboard/'
    | '/dashboard/analytics/models'
    | '/dashboard/canvas/$uuid'
    | '/dashboard/jobs/$id'
    | '/dashboard/model-management/$'
    | '/dashboard/todo/$categoryId'
    | '/dashboard/todo/categories'
    | '/dashboard/users/$id'
    | '/dashboard/wallets/$userId'
    | '/dashboard/canvas/'
    | '/dashboard/jobs/'
    | '/dashboard/model-management/'
    | '/dashboard/todo/'
    | '/dashboard/users/'
    | '/dashboard/wallets/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/dashboard/audit-logs'
    | '/dashboard/earnings'
    | '/dashboard/files'
    | '/dashboard/invites'
    | '/dashboard/projects'
    | '/dashboard/subscriptions'
    | '/dashboard/waitlist'
    | '/dashboard'
    | '/dashboard/analytics/models'
    | '/dashboard/canvas/$uuid'
    | '/dashboard/jobs/$id'
    | '/dashboard/model-management/$'
    | '/dashboard/todo/$categoryId'
    | '/dashboard/todo/categories'
    | '/dashboard/users/$id'
    | '/dashboard/wallets/$userId'
    | '/dashboard/canvas'
    | '/dashboard/jobs'
    | '/dashboard/model-management'
    | '/dashboard/todo'
    | '/dashboard/users'
    | '/dashboard/wallets'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/login'
    | '/dashboard/audit-logs'
    | '/dashboard/earnings'
    | '/dashboard/files'
    | '/dashboard/invites'
    | '/dashboard/projects'
    | '/dashboard/subscriptions'
    | '/dashboard/waitlist'
    | '/dashboard/'
    | '/dashboard/analytics/models'
    | '/dashboard/canvas/$uuid'
    | '/dashboard/jobs/$id'
    | '/dashboard/model-management/$'
    | '/dashboard/todo/$categoryId'
    | '/dashboard/todo/categories'
    | '/dashboard/users/$id'
    | '/dashboard/wallets/$userId'
    | '/dashboard/canvas/'
    | '/dashboard/jobs/'
    | '/dashboard/model-management/'
    | '/dashboard/todo/'
    | '/dashboard/users/'
    | '/dashboard/wallets/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRoute: typeof DashboardRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/waitlist': {
      id: '/dashboard/waitlist'
      path: '/waitlist'
      fullPath: '/dashboard/waitlist'
      preLoaderRoute: typeof DashboardWaitlistRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/subscriptions': {
      id: '/dashboard/subscriptions'
      path: '/subscriptions'
      fullPath: '/dashboard/subscriptions'
      preLoaderRoute: typeof DashboardSubscriptionsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/projects': {
      id: '/dashboard/projects'
      path: '/projects'
      fullPath: '/dashboard/projects'
      preLoaderRoute: typeof DashboardProjectsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/invites': {
      id: '/dashboard/invites'
      path: '/invites'
      fullPath: '/dashboard/invites'
      preLoaderRoute: typeof DashboardInvitesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/files': {
      id: '/dashboard/files'
      path: '/files'
      fullPath: '/dashboard/files'
      preLoaderRoute: typeof DashboardFilesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/earnings': {
      id: '/dashboard/earnings'
      path: '/earnings'
      fullPath: '/dashboard/earnings'
      preLoaderRoute: typeof DashboardEarningsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/audit-logs': {
      id: '/dashboard/audit-logs'
      path: '/audit-logs'
      fullPath: '/dashboard/audit-logs'
      preLoaderRoute: typeof DashboardAuditLogsRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/wallets/': {
      id: '/dashboard/wallets/'
      path: '/wallets'
      fullPath: '/dashboard/wallets/'
      preLoaderRoute: typeof DashboardWalletsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/users/': {
      id: '/dashboard/users/'
      path: '/users'
      fullPath: '/dashboard/users/'
      preLoaderRoute: typeof DashboardUsersIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/todo/': {
      id: '/dashboard/todo/'
      path: '/todo'
      fullPath: '/dashboard/todo/'
      preLoaderRoute: typeof DashboardTodoIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/model-management/': {
      id: '/dashboard/model-management/'
      path: '/model-management'
      fullPath: '/dashboard/model-management/'
      preLoaderRoute: typeof DashboardModelManagementIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/jobs/': {
      id: '/dashboard/jobs/'
      path: '/jobs'
      fullPath: '/dashboard/jobs/'
      preLoaderRoute: typeof DashboardJobsIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/canvas/': {
      id: '/dashboard/canvas/'
      path: '/canvas'
      fullPath: '/dashboard/canvas/'
      preLoaderRoute: typeof DashboardCanvasIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/wallets/$userId': {
      id: '/dashboard/wallets/$userId'
      path: '/wallets/$userId'
      fullPath: '/dashboard/wallets/$userId'
      preLoaderRoute: typeof DashboardWalletsUserIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/users/$id': {
      id: '/dashboard/users/$id'
      path: '/users/$id'
      fullPath: '/dashboard/users/$id'
      preLoaderRoute: typeof DashboardUsersIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/todo/categories': {
      id: '/dashboard/todo/categories'
      path: '/todo/categories'
      fullPath: '/dashboard/todo/categories'
      preLoaderRoute: typeof DashboardTodoCategoriesRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/todo/$categoryId': {
      id: '/dashboard/todo/$categoryId'
      path: '/todo/$categoryId'
      fullPath: '/dashboard/todo/$categoryId'
      preLoaderRoute: typeof DashboardTodoCategoryIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/model-management/$': {
      id: '/dashboard/model-management/$'
      path: '/model-management/$'
      fullPath: '/dashboard/model-management/$'
      preLoaderRoute: typeof DashboardModelManagementSplatRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/jobs/$id': {
      id: '/dashboard/jobs/$id'
      path: '/jobs/$id'
      fullPath: '/dashboard/jobs/$id'
      preLoaderRoute: typeof DashboardJobsIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/canvas/$uuid': {
      id: '/dashboard/canvas/$uuid'
      path: '/canvas/$uuid'
      fullPath: '/dashboard/canvas/$uuid'
      preLoaderRoute: typeof DashboardCanvasUuidRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/analytics/models': {
      id: '/dashboard/analytics/models'
      path: '/analytics/models'
      fullPath: '/dashboard/analytics/models'
      preLoaderRoute: typeof DashboardAnalyticsModelsRouteImport
      parentRoute: typeof DashboardRoute
    }
  }
}

interface DashboardRouteChildren {
  DashboardAuditLogsRoute: typeof DashboardAuditLogsRoute
  DashboardEarningsRoute: typeof DashboardEarningsRoute
  DashboardFilesRoute: typeof DashboardFilesRoute
  DashboardInvitesRoute: typeof DashboardInvitesRoute
  DashboardProjectsRoute: typeof DashboardProjectsRoute
  DashboardSubscriptionsRoute: typeof DashboardSubscriptionsRoute
  DashboardWaitlistRoute: typeof DashboardWaitlistRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardAnalyticsModelsRoute: typeof DashboardAnalyticsModelsRoute
  DashboardCanvasUuidRoute: typeof DashboardCanvasUuidRoute
  DashboardJobsIdRoute: typeof DashboardJobsIdRoute
  DashboardModelManagementSplatRoute: typeof DashboardModelManagementSplatRoute
  DashboardTodoCategoryIdRoute: typeof DashboardTodoCategoryIdRoute
  DashboardTodoCategoriesRoute: typeof DashboardTodoCategoriesRoute
  DashboardUsersIdRoute: typeof DashboardUsersIdRoute
  DashboardWalletsUserIdRoute: typeof DashboardWalletsUserIdRoute
  DashboardCanvasIndexRoute: typeof DashboardCanvasIndexRoute
  DashboardJobsIndexRoute: typeof DashboardJobsIndexRoute
  DashboardModelManagementIndexRoute: typeof DashboardModelManagementIndexRoute
  DashboardTodoIndexRoute: typeof DashboardTodoIndexRoute
  DashboardUsersIndexRoute: typeof DashboardUsersIndexRoute
  DashboardWalletsIndexRoute: typeof DashboardWalletsIndexRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardAuditLogsRoute: DashboardAuditLogsRoute,
  DashboardEarningsRoute: DashboardEarningsRoute,
  DashboardFilesRoute: DashboardFilesRoute,
  DashboardInvitesRoute: DashboardInvitesRoute,
  DashboardProjectsRoute: DashboardProjectsRoute,
  DashboardSubscriptionsRoute: DashboardSubscriptionsRoute,
  DashboardWaitlistRoute: DashboardWaitlistRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardAnalyticsModelsRoute: DashboardAnalyticsModelsRoute,
  DashboardCanvasUuidRoute: DashboardCanvasUuidRoute,
  DashboardJobsIdRoute: DashboardJobsIdRoute,
  DashboardModelManagementSplatRoute: DashboardModelManagementSplatRoute,
  DashboardTodoCategoryIdRoute: DashboardTodoCategoryIdRoute,
  DashboardTodoCategoriesRoute: DashboardTodoCategoriesRoute,
  DashboardUsersIdRoute: DashboardUsersIdRoute,
  DashboardWalletsUserIdRoute: DashboardWalletsUserIdRoute,
  DashboardCanvasIndexRoute: DashboardCanvasIndexRoute,
  DashboardJobsIndexRoute: DashboardJobsIndexRoute,
  DashboardModelManagementIndexRoute: DashboardModelManagementIndexRoute,
  DashboardTodoIndexRoute: DashboardTodoIndexRoute,
  DashboardUsersIndexRoute: DashboardUsersIndexRoute,
  DashboardWalletsIndexRoute: DashboardWalletsIndexRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRoute: DashboardRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
